/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it 
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VehicleSummaryEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  VehicleSummaryProps,
  VehicleSummaryViewModelBase,
} from 'src/store/generated/vehicle-summary-record.generated';
import { UnitSummaryViewModel } from './unit-summary-view-model';
import { vehicleStatusDisplay } from './vehicle-disposition-view-model';
import { vehicleDisplayName } from './vehicle-view-model';

export class VehicleSummaryViewModel extends VehicleSummaryViewModelBase {
  constructor(props: VehicleSummaryProps) {
    super(props);
  }

  public getLocationStatusDisplay(unit: UnitSummaryViewModel) {
    if (unit.isExternallyManaged) {
      return `Last Known: ${this.statusDescription}`;
    }
    if (this.isEnRoute) {
      const toName = this.to != null ? this.to.name : 'unknown';
      return `En-Route ${toName}`;
    }
    const fromName = this.from != null ? this.from.name : 'unknown';
    return `@ ${fromName}`;
  }

  get displayName(): string {
    return vehicleDisplayName({
      makeName: this.makeName,
      modelName: this.modelName,
      registrationNumber: this.registrationNumber,
    });
  }

  get statusDisplay() {
    return vehicleStatusDisplay(this.status);
  }

  get currentWaypoint() {
    if (this.isAtWaypoint && this.from != null) {
      return this.from;
    }
    return undefined;
  }

  get hasTrip() {
    return this._props.currentCardSummaryId != null && this._props.currentOrNextLegSequence != null;
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleSummaryViewModelService {
  constructor(private readonly _vehicleSummaryFetchService: VehicleSummaryEntityFetchService) {}

  public getById(id: string): Observable<VehicleSummaryViewModel | undefined> {
    return this._vehicleSummaryFetchService.getById(id).pipe(
      map((vehicleSummary) => {
        if (vehicleSummary == null) {
          return undefined;
        }
        return new VehicleSummaryViewModel(vehicleSummary);
      }),
    );
  }
}
